import { ArrowUpRight } from "lucide-react";
import { PORTFOLIO } from "../../data/mock";

export default function Portfolio() {
  return (
    <section
      id="work"
      data-testid="portfolio-section"
      className="py-24 md:py-32 bg-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <span className="eyebrow" data-testid="portfolio-eyebrow">Selected work</span>
            <h2
              data-testid="portfolio-heading"
              className="font-display text-4xl md:text-5xl lg:text-[56px] leading-[1.05] mt-6 text-navy"
            >
              Stories, brands, &
              <span className="italic text-terracotta"> systems.</span>
            </h2>
          </div>
          <p className="text-lg text-ink-muted max-w-md">
            A snapshot of recent projects across consulting, design, and editorial.
            Full case studies available on request.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-10">
          {PORTFOLIO.map((p, i) => (
            <a
              key={i}
              href="#contact"
              data-testid={`portfolio-card-${i}`}
              className="group block"
            >
              <div className="relative overflow-hidden aspect-[4/5] mb-5">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4 bg-cream text-navy px-3 py-1.5 text-xs uppercase tracking-[0.18em] font-semibold">
                  {p.category}
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 bg-terracotta text-cream flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <ArrowUpRight size={18} />
                </div>
              </div>
              <h3 className="font-display text-2xl md:text-3xl text-navy group-hover:text-terracotta transition-colors">
                {p.title}
              </h3>
              <p className="mt-2 text-ink-muted text-[17px] leading-relaxed">
                {p.blurb}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
